import React from 'react';
import clsx from 'classnames';
import { InputPresets } from './input.presets';

import styles from './input.module.scss';

export const Input = (props: any) => {
  const {
    children,
    className,
    error,
    help,
    label,
    onBlur,
    onChange,
    placeholder,
    prefix,
    required,
    suffix,
    type = 'text',
    value,
    ...other
  } = { ...InputPresets, ...props } as any;

  return (
    <div className={clsx(styles.inputContainer, { [styles.inputInvalid]: error }, className)}>
      {label && (
        <label>
          {required && <span className={styles.required}>*</span>} {label}
        </label>
      )}
      <div className="mt-1 relative shadow-sm">
        {children || (
          <input
            className={clsx({ 'pl-10': prefix, 'pr-10': suffix })}
            placeholder={placeholder}
            type={type}
            value={value}
            onBlur={onBlur}
            onChange={onChange}
            {...other}
          />
        )}
        {suffix && <div className="absolute inset-y-0 right-0 pr-1 flex items-center">{suffix}</div>}
        {prefix && <div className="absolute inset-y-0 left-0 pl-3 flex items-center">{prefix}</div>}
      </div>
      {help && !error && <p className="mt-2 text-sm text-gray-500">{help}</p>}
      {error && <p className={styles.invalidFeedback}>{error}</p>}
    </div>
  );
};

export default Input;
